import styles from "./styles.module.css";
import { ReactComponent as Icon } from "../../../assets/result-icon.svg";
import DataCard from "./DataCard";
import { FiDownload } from "react-icons/fi";
import PDFDocument from "../PDF/index";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Button from "../../../components/Button";
import ClipLoader from "react-spinners/ClipLoader";
import Box from "../../../components/Box";

function Results({ dataManager, onNext }) {
  const { data } = dataManager;
  
  return (
    <>
      <Box className={styles.resultBox}>
        <div className={styles.iconWrapper}>
          <Icon />
        </div>
        <div className={styles.titleContainer}>
          <h3>Simulação concluída</h3>
          <span>Veja o resultado</span>
        </div>
        <div className={styles.dataContainer}>
          <DataCard value={data.selectedBem.nome} title={"Nome do Bem"} />
          <div className={styles.valuesContainer}>
            <DataCard
              value={data.plano?.grupo?.valorBem * data.multiple}
              title={"Valor do Consórcio"}
              multiple={data.multiple}
            />
            <DataCard
              value={data.plano.grupo?.valorParcela * data.multiple}
              title={"Valor da Parcela"}
              multiple={data.multiple}
            />
            <DataCard
              value={`${data.plano.grupo?.quantidadeMesesPrazo}`}
              title={"Número de Parcelas"}
            />
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <div className={styles.mainButtons}>
            <Button
              onClick={() =>
                (window.location.href = `https://bb.guerraconsorcios.com.br/`)
              }
            >
              Contratar
            </Button>
            <Button outline onClick={() => window.location.reload()}>
              Simular Novamente
            </Button>
          </div>
          <PDFDownloadLink
            document={<PDFDocument data={data} />}
            fileName="simulacao.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? (
                <ClipLoader
                  color={"var(--blue)"}
                  size={15}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                <FiDownload size={20} />
              )
            }
          </PDFDownloadLink>
        </div>
      </Box>
    </>
  );
}
export default Results;
